<template>
  <PubPage>
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="addModule('add')"
            >添加账户</a-button
          >
        </div>
      </template>

      <template slot="accountType" slot-scope="{ record }">
        <PubStatus :status="record.accountType" type="USER_ACCOUNT_TYPE" />
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="addModule('edit', record)"><a-icon type="form" />编辑 </a>
          <a @click="changePasswordOpen(record)" class="green">
            <a-icon type="tool" />修改密码
          </a>
          <a @click="deleteUser(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddMember ref="addMemberModal" @ok="moduleOk" />
    <ChangePassword ref="changePasswordModal" />
  </PubPage>
</template>

<script>
import { Setting } from "@/api";
import AddMember from "./AddMember.vue";
import ChangePassword from "@/components/PublicModals/ChangePassword.vue";
export default {
  components: {
    AddMember,
    ChangePassword,
  },
  data() {
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        align: "center",
        hideInSearch: true,
        width: 50,
      },
      {
        title: "账号",
        dataIndex: "userCode",
        align: "center",
      },
      {
        title: "用户",
        dataIndex: "userName",
        align: "center",
      },
      {
        title: "手机号",
        dataIndex: "telephone",
        align: "center",
      },
      {
        title: "学校",
        dataIndex: "schoolName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "学校",
        dataIndex: "schoolId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择学校",
          option: () => this.common.getAllSchool(),
        },
      },
      {
        title: "账号类型",
        dataIndex: "accountType",
        align: "center",
        scopedSlots: true,
        hideInSearch: true,
        width: 100,
      },
      {
        title: "状态",
        dataIndex: "status",
        align: "center",
        scopedSlots: true,
        width: 80,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYS_STATUS"),
        },
      },
      {
        title: "操作",
        dataIndex: "options",
        align: "center",
        width: 210,
        scopedSlots: true,
        hideInSearch: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
        },
      },
      list: [],
      pagination: {},
      loading: false,
      columns,
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList() {
      this.loading = true;
      Setting.sysUserPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },

    // 删除
    deleteUser(id) {
      this.pubMsg.confirm("是否确定删除此账户？").then(() => {
        this.loading = true;
        Setting.sysUserDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.loading = false;
            this.getList();
          }
        });
      });
    },
    addModule(type, data) {
      this.$refs.addMemberModal.open(type, data);
    },
    changePasswordOpen(data) {
      this.$refs.changePasswordModal.open(data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
